(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fere-whatsapp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fere-whatsapp')) {
    customElements.define('fere-whatsapp', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const toggle = this.querySelector('#tm-wa-toggle');
        const popup = this.querySelector('#tm-wa-popup');
        const close = this.querySelector('#tm-wa-close');
        const time = this.querySelector('#tm-wa-time');
        if (!toggle || !popup || !close) return;
        const setOpen = (open, restoreFocus = false) => {
          popup.hidden = !open;
          toggle.setAttribute('aria-expanded', String(open));
          if (open) {
            time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'ro', { hour: '2-digit', minute: '2-digit' }).format(new Date());
            close.focus();
          } else if (restoreFocus) {
            toggle.focus();
          }
        };
        const reveal = () => {
          const height = document.documentElement.scrollHeight - window.innerHeight;
          const percent = height > 0 ? window.scrollY / height * 100 : 100;
          if (percent >= Number(this.dataset.scroll || 0)) {
            this.classList.add('tm-visible');
            this.setAttribute('aria-hidden', 'false');
            window.removeEventListener('scroll', reveal);
            window.removeEventListener('resize', reveal);
          }
        };
        window.addEventListener('scroll', reveal, { ...options, passive: true });
        window.addEventListener('resize', reveal, options);
        toggle.addEventListener('click', () => setOpen(popup.hidden), options);
        close.addEventListener('click', () => setOpen(false, true), options);
        document.addEventListener('click', (event) => {
          if (!popup.hidden && !this.contains(event.target)) setOpen(false);
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !popup.hidden) setOpen(false, true);
        }, options);
        reveal();
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
